import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Button,
  Container,
  Content,
  Header,
  Loader,
  CheckPicker,
  DatePicker,
  SelectPicker,
  InputGroup,
  Modal,
} from "rsuite";
import { Form, Field, FormSpy } from "react-final-form";
import SaveIcon from "@rsuite/icons/AddOutline";
import CloseIcon from "@rsuite/icons/Close";
import { render } from "react-dom";
import { HelperServices } from "../../../core/services/HelperServices";
import "./Company.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import { get } from "lodash/fp";
import { UtilityServices } from "../../../core/services/UtilityServices";
import { useSelector } from "react-redux";
import CustomSelector from "../../shared/customSelector";
import { useTranslation } from "react-i18next";
import {
  messageTypeArr,
  roleTypeArr,
  yesNoObjArr,
  dateFormatObj,
  fullDayTimeObjArr,
  defaultMasterRuleObj,
} from "../../../core/config/AppConstants";
import { ContentRoutes } from "../../../navigation/NavConstant";
import {
  addLabelValue,
  calenderDateToDB,
  compareTimes,
  dbDateToCalender,
  displayField,
  generateTimeOptions,
  isEmptyVal,
  isNotEmpty,
  isNotNull,
} from "../../../utils/helpers";
import { CompanyServices } from "../../../core/services/CompanyServices";
import { AlertModal } from "../../components/Modals/AlertModal/AlertModal";
function CompanyMasterRule({
  companyId,
  openModal,
  setOpenModal,
  onComplete,
}: {
  companyId: number;
  openModal: boolean;
  setOpenModal: Function;
  onComplete?: Function;
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");
  const [loader, setLoading] = useState(false);
  const [masterRuleId, setMasterRuleId] = useState<number>(null);
  const params: any = useParams();
  const company = useSelector((state: any) => state.company);
  const [timeSlots, setTimeSlots] = useState(
    defaultMasterRuleObj.multimedia_day_parts
  );
  const [playerStopTime, setPlayerStopTime] = useState(null);
  const [formData, setFormData] = useState<any>({
    company_id: companyId,
    enable_commercial: defaultMasterRuleObj.enable_commercial,
    play_default_music_schedule:
      defaultMasterRuleObj.play_default_music_schedule,
    commercial_per_hour: defaultMasterRuleObj.commercial_per_hour,
    commercial_per_day: defaultMasterRuleObj.commercial_per_day,
    multimedia_day_parts: defaultMasterRuleObj.multimedia_day_parts,
    music_volume: defaultMasterRuleObj.music_volume,
    commercial_volume: defaultMasterRuleObj.commercial_volume,
    player_stop_time: null,
  });

  const [companyData, setCompanyData] = useState<any>({});

  async function init() {
    try {
      if (companyId) {
        const response: any = await CompanyServices.viewCompany(+companyId);
        const respData = get("data.data", response);
        const masterRuleData = respData?.company_master_rule;
        const keyMapper: any = {};

        let obj = { ...formData };

        let keyMapperIndex = Object.keys(keyMapper);
        if (masterRuleData) {
          Object.keys(obj).map((formKeys) => {
            if (keyMapperIndex.includes(formKeys)) {
              obj[formKeys] = masterRuleData[keyMapper[formKeys]];
            } else if (formKeys === "status") {
              obj[formKeys] = masterRuleData?.status.toString();
            } else if (masterRuleData[formKeys]) {
              obj[formKeys] = masterRuleData[formKeys];
            }
          });

          setTimeSlots(masterRuleData?.multimedia_day_parts);
          setPlayerStopTime(masterRuleData?.player_stop_time);
          setMasterRuleId(masterRuleData?.id);
        }

        setFormData({ ...obj });
        setCompanyData(respData);
      }
    } catch (error: any) {
      UtilityServices.showToaster({
        message: error?.message,
        type: messageTypeArr.error,
      });
    }
  }

  useEffect(() => {
    init();
  }, [companyId]);

  useEffect(() => {}, [company.id]);

  async function saveMasterRule(form: any, id?: number) {
    try {
      setLoading(true);
      let response: any;
      if (id) {
        response = await CompanyServices.updateMasterRule(+id, form);
      } else {
        response = await CompanyServices.createMasterRule(form);
        setMasterRuleId(response?.data?.data?.id);
      }
      setLoading(false);
      UtilityServices.showToaster({
        message: response?.data?.message,
      });
    } catch (error: any) {
      setLoading(false);
      UtilityServices.showToaster({
        message: error?.message,
        type: messageTypeArr.error,
      });
      setErrorMessage(error?.message);
    }
  }

  const addTimeSlot = (index) => {
    const new_slot: any = {
      slot_title: "",
      start_hour: timeSlots[index]["end_hour"],
      end_hour: timeSlots[index]["end_hour"],
    };
    if (isEmptyVal(timeSlots[index]["slot_title"])) {
      UtilityServices.showToaster({
        type: "warning",
        message: t("REQUIRED", {
          field: t("DAY").toLowerCase() + " " + t("PART").toLowerCase(),
        }),
      });
      return;
    }
    if (isEmptyVal(timeSlots[index]["start_hour"])) {
      UtilityServices.showToaster({
        type: "warning",
        message: t("REQUIRED", {
          field: t("START").toLowerCase() + " " + t("TIME").toLowerCase(),
        }),
      });
      return;
    }
    if (isEmptyVal(timeSlots[index]["end_hour"])) {
      UtilityServices.showToaster({
        type: "warning",
        message: t("REQUIRED", {
          field: t("END").toLowerCase() + " " + t("TIME").toLowerCase(),
        }),
      });
      return;
    }
    if (
      compareTimes(
        timeSlots[index]["end_hour"],
        timeSlots[index]["start_hour"]
      ) < 1
    ) {
      UtilityServices.showToaster({
        type: "warning",
        message: t("DATE2_SHALL_BE_GREATER_THAN_DATE1", {
          date2: t("END").toLowerCase() + " " + t("TIME").toLowerCase(),
          date1: t("START").toLowerCase() + " " + t("TIME").toLowerCase(),
        }),
      });
      return;
    }
    let nextData: any = {};
    nextData = Object.assign([], timeSlots);
    nextData[timeSlots?.length] = new_slot;

    setTimeSlots(nextData);
  };

  const removeTimeSlot = (index) => {
    removeTimeSlotRow(index);
  };

  const removeTimeSlotRow = (index) => {
    const updatedSlots = timeSlots.filter((_, i) => i !== index);
    setTimeSlots(updatedSlots);
  };

  const handleTimeSlotChanges = (indexId: Number, key: any, value: any) => {
    let nextData: any = {};
    nextData = Object.assign([], timeSlots);

    nextData.forEach((item, index) => {
      if (index === indexId) {
        item[key] = value;
      }
    });
    setTimeSlots(nextData);
  };

  const addPlayerStopTime = (index) => {
    const new_stop_time: any = {
      reason: "",
      stop_at: playerStopTime[index]["stop_at"],
      stop_end_at: playerStopTime[index]["stop_end_at"],
    };

    if (isEmptyVal(playerStopTime[index]["stop_at"])) {
      UtilityServices.showToaster({
        type: "warning",
        message: t("REQUIRED", {
          field: t("STOP").toLowerCase() + " " + t("TIME").toLowerCase(),
        }),
      });
      return;
    }
    if (isEmptyVal(playerStopTime[index]["stop_end_at"])) {
      UtilityServices.showToaster({
        type: "warning",
        message: t("REQUIRED", {
          field:
            t("STOP").toLowerCase() +
            " " +
            t("END").toLowerCase() +
            " " +
            t("TIME").toLowerCase(),
        }),
      });
      return;
    }
    if (
      compareTimes(
        playerStopTime[index]["stop_end_at"],
        playerStopTime[index]["stop_at"]
      ) < 1
    ) {
      UtilityServices.showToaster({
        type: "warning",
        message: t("DATE2_SHALL_BE_GREATER_THAN_DATE1", {
          date2:
            t("STOP").toLowerCase() +
            " " +
            t("END").toLowerCase() +
            " " +
            t("TIME").toLowerCase(),
          date1: t("STOP").toLowerCase() + " " + t("TIME").toLowerCase(),
        }),
      });
      return;
    }
    if (isEmptyVal(playerStopTime[index]["reason"])) {
      UtilityServices.showToaster({
        type: "warning",
        message: t("REQUIRED", {
          field: t("REASON").toLowerCase(),
        }),
      });
      return;
    }
    let nextData: any = {};
    nextData = Object.assign([], playerStopTime);
    nextData[playerStopTime.length] = new_stop_time;

    setPlayerStopTime(nextData);
  };

  const removePlayerStopTime = (index) => {
    removePlayerStopRow(index);
  };

  const removePlayerStopRow = (index) => {
    const updatedTime = playerStopTime.filter((_, i) => i !== index);
    setPlayerStopTime(updatedTime);
  };

  const handlePlayerStopTimeChanges = (
    indexId: Number,
    key: any,
    value: any
  ) => {
    let nextData: any = {};
    nextData = Object.assign([], playerStopTime);

    nextData.forEach((item, index) => {
      if (index === indexId) {
        item[key] = value;
      }
    });
    setPlayerStopTime(nextData);
  };

  function getCompanyId() {
    let compId = null;
    if (UtilityServices.getLoggedInUser("user_type") === roleTypeArr.client) {
      compId = UtilityServices.getLoggedInUser("company_id");
    } else if (companyId) {
      compId = companyId;
    } else if (company?.id) {
      compId = company.id;
    }
    return compId;
  }

  const onSubmit = (val: any) => {
    const form = new FormData();
    for (var key in formData) {
      if (isNotNull(val[key])) {
        form.append(key, val[key]);
      }
    }
    form.append("multimedia_day_parts", JSON.stringify(timeSlots));
    form.append("player_stop_time", JSON.stringify(playerStopTime));

    if (!getCompanyId()) {
      UtilityServices.showToaster({
        type: "warning",
        message: t("PLEASE_SELECT_FIELD", {
          field: t("COMPANY").toLowerCase(),
        }),
      });
      return;
    }
    if (+masterRuleId > 0) {
      saveMasterRule(form, masterRuleId);
    } else {
      form.set("company_id", getCompanyId());
      saveMasterRule(form);
    }
  };

  return (
    <div className="modal-container">
      <Modal
        open={openModal}
        backdrop={true}
        onClose={(e: any) => {
          setOpenModal("");
        }}
        size="full"
      >
        {loader && (
          <Loader
            style={{ zIndex: 9999 }}
            size="lg"
            content={t("LOADING")}
            center
            backdrop={true}
          />
        )}
        <Modal.Header>
          <h4>
            {" "}
            {t("MASTER") + " " + t("RULE") + " " + t("FOR") + " "}{" "}
            {displayField(`${companyData?.comp_name}`)}
          </h4>
        </Modal.Header>
        <Modal.Body>
          <Container className="container">
            <Header className="header"></Header>
            <Content className="content user-create-wrap">
              <Form
                onSubmit={onSubmit}
                validate={(values: any) => {
                  const errors: any = {};
                  if (values.enable_commercial === "") {
                    errors.enable_commercial = t("REQUIRED", {
                      field:
                        t("ENABLE").toLowerCase() +
                        " " +
                        t("COMMERCIAL").toLowerCase(),
                    });
                  }
                  if (
                    values.enable_commercial &&
                    (!values.commercial_per_hour ||
                      values.commercial_per_hour < 1)
                  ) {
                    errors.commercial_per_hour = t("REQUIRED", {
                      field:
                        t("COMMERCIAL").toLowerCase() +
                        " " +
                        t("PER").toLowerCase() +
                        " " +
                        t("HOUR").toLowerCase(),
                    });
                  }
                  if (
                    values.enable_commercial &&
                    (!values.commercial_per_day ||
                      values.commercial_per_day < 1)
                  ) {
                    errors.commercial_per_day = t("REQUIRED", {
                      field:
                        t("COMMERCIAL").toLowerCase() +
                        " " +
                        t("PER").toLowerCase() +
                        " " +
                        t("DAY").toLowerCase(),
                    });
                  }

                  if (!values.music_volume || values.music_volume < 1) {
                    errors.music_volume = t("REQUIRED", {
                      field:
                        t("MUSIC").toLowerCase() +
                        " " +
                        t("VOLUME").toLowerCase(),
                    });
                  }

                  if (
                    !values.commercial_volume ||
                    values.commercial_volume < 1
                  ) {
                    errors.commercial_volume = t("REQUIRED", {
                      field:
                        t("COMMERCIAL").toLowerCase() +
                        " " +
                        t("VOLUME").toLowerCase(),
                    });
                  }
                  let nameTaken = [],
                    startTimeTaken = [],
                    endTimeTaken = [];
                  for (let i = 0; i < timeSlots?.length; i++) {
                    if (isEmptyVal(timeSlots[i]["slot_title"])) {
                      errors["slot_title" + i] = t("REQUIRED", {
                        field:
                          t("SLOT").toLowerCase() +
                          " " +
                          t("TITLE").toLowerCase(),
                      });
                    } else if (
                      nameTaken.includes(timeSlots[i]["slot_title"]) &&
                      isEmptyVal(timeSlots[i]["id"])
                    ) {
                      errors["slot_title" + i] = t("VALUE_TAKEN", {
                        value: timeSlots[i]["slot_title"],
                      });
                    } else {
                      nameTaken.push(timeSlots[i]["slot_title"]);
                    }

                    if (isEmptyVal(timeSlots[i]["start_hour"])) {
                      errors["start_hour" + i] = t("REQUIRED", {
                        field:
                          t("START").toLowerCase() +
                          " " +
                          t("TIME").toLowerCase(),
                      });
                    } else if (
                      startTimeTaken.includes(timeSlots[i]["start_hour"]) &&
                      isEmptyVal(timeSlots[i]["id"])
                    ) {
                      errors["start_hour" + i] = t("VALUE_TAKEN", {
                        value: timeSlots[i]["start_hour"],
                      });
                    } else {
                      startTimeTaken.push(timeSlots[i]["start_hour"]);
                    }

                    if (isEmptyVal(timeSlots[i]["end_hour"])) {
                      errors["end_hour" + i] = t("REQUIRED", {
                        field:
                          t("END").toLowerCase() +
                          " " +
                          t("TIME").toLowerCase(),
                      });
                    } else if (
                      endTimeTaken.includes(timeSlots[i]["end_hour"]) &&
                      isEmptyVal(timeSlots[i]["id"])
                    ) {
                      errors["end_hour" + i] = t("VALUE_TAKEN", {
                        value: timeSlots[i]["end_hour"],
                      });
                    } else {
                      endTimeTaken.push(timeSlots[i]["end_hour"]);
                    }

                    if (
                      compareTimes(
                        timeSlots[i]["end_hour"],
                        timeSlots[i]["start_hour"]
                      ) < 1
                    ) {
                      errors["end_hour" + i] = t(
                        "DATE2_SHALL_BE_GREATER_THAN_DATE1",
                        {
                          date2:
                            t("END").toLowerCase() +
                            " " +
                            t("TIME").toLowerCase(),
                          date1:
                            t("START").toLowerCase() +
                            " " +
                            t("TIME").toLowerCase(),
                        }
                      );
                    }
                  }

                  startTimeTaken = [];
                  endTimeTaken = [];
                  for (let i = 0; i < playerStopTime?.length; i++) {
                    if (isEmptyVal(playerStopTime[i]["reason"])) {
                      errors["reason" + i] = t("REQUIRED", {
                        field: t("REASON").toLowerCase(),
                      });
                    }

                    if (isEmptyVal(playerStopTime[i]["stop_at"])) {
                      errors["stop_at" + i] = t("REQUIRED", {
                        field:
                          t("STOP").toLowerCase() +
                          " " +
                          t("TIME").toLowerCase(),
                      });
                    } else if (
                      startTimeTaken.includes(playerStopTime[i]["stop_at"])
                    ) {
                      errors["stop_at" + i] = t("VALUE_TAKEN", {
                        value: playerStopTime[i]["stop_at"],
                      });
                    } else {
                      startTimeTaken.push(playerStopTime[i]["stop_at"]);
                    }

                    if (isEmptyVal(playerStopTime[i]["stop_end_at"])) {
                      errors["stop_end_at" + i] = t("REQUIRED", {
                        field:
                          t("STOP").toLowerCase() +
                          " " +
                          t("END").toLowerCase() +
                          " " +
                          t("TIME").toLowerCase(),
                      });
                    } else if (
                      endTimeTaken.includes(playerStopTime[i]["stop_end_at"])
                    ) {
                      errors["stop_end_at" + i] = t("VALUE_TAKEN", {
                        value: playerStopTime[i]["stop_end_at"],
                      });
                    } else {
                      endTimeTaken.push(playerStopTime[i]["stop_end_at"]);
                    }

                    if (
                      compareTimes(
                        playerStopTime[i]["stop_end_at"],
                        playerStopTime[i]["stop_at"]
                      ) < 1
                    ) {
                      errors["stop_end_at" + i] = t(
                        "DATE2_SHALL_BE_GREATER_THAN_DATE1",
                        {
                          date2:
                            t("STOP").toLowerCase() +
                            " " +
                            t("END").toLowerCase() +
                            " " +
                            t("TIME").toLowerCase(),
                          date1:
                            t("STOP").toLowerCase() +
                            " " +
                            t("TIME").toLowerCase(),
                        }
                      );
                    }
                  }
                  return errors;
                }}
                initialValues={{ ...formData }}
                render={({ handleSubmit, form }) => (
                  <>
                    <FormSpy
                      subscription={{ values: true }}
                      onChange={({ values }) => setFormData(values)}
                    />
                    <form onSubmit={handleSubmit}>
                      <div className="form-part">
                        <div className="flex-container">
                          <Field name="enable_commercial">
                            {({ input, meta }) => (
                              <div className="flex-item">
                                <CustomSelector
                                  loaderMsg={null}
                                  isRequired={true}
                                  valueKey="value"
                                  labelKey="label"
                                  labelName={
                                    t("ENABLE") + " " + t("COMMERCIAL")
                                  }
                                  defaultValue={input.value}
                                  onClear={(event: any) => {
                                    form.change("enable_commercial", "");
                                  }}
                                  listData={yesNoObjArr}
                                  onSelect={(e: any, selectedObj: any) => {
                                    form.change("enable_commercial", e);
                                  }}
                                />
                                {meta.error && meta.touched && (
                                  <span>{meta.error}</span>
                                )}
                              </div>
                            )}
                          </Field>
                          <Field name="commercial_per_hour">
                            {({ input, meta }) => (
                              <div className="flex-item">
                                <label>
                                  {t("COMMERCIAL")} {t("PER")} {t("HOUR")}*
                                </label>
                                <input
                                  {...input}
                                  type="number"
                                  autoComplete="off"
                                  min="0"
                                />
                                {meta.error && meta.touched && (
                                  <span>{meta.error}</span>
                                )}
                              </div>
                            )}
                          </Field>
                          <Field name="commercial_per_day">
                            {({ input, meta }) => (
                              <div className="flex-item">
                                <label>
                                  {t("COMMERCIAL")} {t("PER")} {t("DAY")}*
                                </label>
                                <input
                                  {...input}
                                  type="number"
                                  autoComplete="off"
                                  min="0"
                                />
                                {meta.error && meta.touched && (
                                  <span>{meta.error}</span>
                                )}
                              </div>
                            )}
                          </Field>
                          <Field name="music_volume">
                            {({ input, meta }) => (
                              <div className="flex-item">
                                <label>
                                  {t("MUSIC")} {t("VOLUME")} *
                                </label>
                                <input
                                  {...input}
                                  type="number"
                                  autoComplete="off"
                                  min="0"
                                />
                                {meta.error && meta.touched && (
                                  <span>{meta.error}</span>
                                )}
                              </div>
                            )}
                          </Field>
                          <Field name="commercial_volume">
                            {({ input, meta }) => (
                              <div className="flex-item">
                                <label>
                                  {t("COMMERCIAL")} {t("VOLUME")} *
                                </label>
                                <input
                                  {...input}
                                  type="number"
                                  autoComplete="off"
                                  min="0"
                                />
                                {meta.error && meta.touched && (
                                  <span>{meta.error}</span>
                                )}
                              </div>
                            )}
                          </Field>
                        </div>
                      </div>
                      <div className="address-bx">
                        <h5>
                          {t("MUSIC") +
                            " " +
                            t("TIME") +
                            " " +
                            t("SLOTS") +
                            " "}
                          {isEmptyVal(timeSlots) && (
                            <Button
                              color="red"
                              type="button"
                              onClick={(e: any) => {
                                setTimeSlots(
                                  defaultMasterRuleObj.multimedia_day_parts
                                );
                              }}
                            >
                              {t("ADD")} {t("TIME")} {t("SLOT")}
                            </Button>
                          )}
                        </h5>
                      </div>
                      <div className="form-part">
                        {timeSlots?.map((item: any, index: number) => (
                          <div className="flex-container">
                            <Field name={"slot_title" + index}>
                              {({ input, meta }) => (
                                <div className="flex-item">
                                  <label>
                                    {t("SLOT")} {t("NAME")}*
                                  </label>
                                  <input
                                    {...input}
                                    type="text"
                                    value={item?.slot_title}
                                    onChange={(e) => {
                                      handleTimeSlotChanges(
                                        index,
                                        "slot_title",
                                        e.target.value
                                      );
                                    }}
                                  />
                                  {meta.error && meta.touched && (
                                    <span>{meta.error}</span>
                                  )}
                                </div>
                              )}
                            </Field>
                            <Field name={"start_hour" + index}>
                              {({ input, meta }) => (
                                <div className="flex-item">
                                  <label>
                                    {t("START")} {t("HOUR")} *
                                  </label>
                                  <SelectPicker
                                    data={fullDayTimeObjArr}
                                    valueKey="value"
                                    labelKey="label"
                                    onSelect={(value, item) => {
                                      handleTimeSlotChanges(
                                        index,
                                        "start_hour",
                                        value
                                      );
                                    }}
                                    onClean={(e: any) => {
                                      handleTimeSlotChanges(
                                        index,
                                        "start_hour",
                                        ""
                                      );
                                    }}
                                    name={"start_hour" + index}
                                    defaultValue={item?.start_hour
                                      .toString()
                                      .slice(0, 5)}
                                    value={item?.start_hour
                                      .toString()
                                      .slice(0, 5)}
                                  />

                                  {meta.error && meta.touched && (
                                    <span>{meta.error}</span>
                                  )}
                                </div>
                              )}
                            </Field>
                            <Field name={"end_hour" + index}>
                              {({ input, meta }) => (
                                <div className="flex-item">
                                  <label>
                                    {t("END")} {t("HOUR")} *
                                  </label>
                                  <SelectPicker
                                    data={fullDayTimeObjArr}
                                    valueKey="value"
                                    labelKey="label"
                                    onSelect={(value, item) => {
                                      handleTimeSlotChanges(
                                        index,
                                        "end_hour",
                                        value
                                      );
                                    }}
                                    onClean={(e: any) => {
                                      handleTimeSlotChanges(
                                        index,
                                        "end_hour",
                                        ""
                                      );
                                    }}
                                    name={"end_hour" + index}
                                    defaultValue={item?.end_hour
                                      .toString()
                                      .slice(0, 5)}
                                    value={item?.end_hour
                                      .toString()
                                      .slice(0, 5)}
                                  />

                                  {meta.error && meta.touched && (
                                    <span>{meta.error}</span>
                                  )}
                                </div>
                              )}
                            </Field>
                            {(timeSlots?.length == 0 ||
                              index === timeSlots?.length - 1) && (
                              <div className=" mb-2 text-right">
                                <label>{t("ACTION")}</label>
                                <InputGroup>
                                  <InputGroup.Button
                                    title={t("ADD")}
                                    onClick={() => addTimeSlot(index)}
                                  >
                                    <SaveIcon />
                                  </InputGroup.Button>
                                  <InputGroup.Button
                                    title={t("CLEAR")}
                                    onClick={() => removeTimeSlot(index)}
                                  >
                                    <CloseIcon />
                                  </InputGroup.Button>
                                </InputGroup>
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                      <div className="address-bx">
                        <h5>
                          {t("PLAYER") +
                            " " +
                            t("STOP") +
                            " " +
                            t("TIME") +
                            " "}
                          {isEmptyVal(playerStopTime) && (
                            <Button
                              color="red"
                              type="button"
                              onClick={(e: any) => {
                                setPlayerStopTime(
                                  defaultMasterRuleObj.player_stop_time
                                );
                              }}
                            >
                              {t("ADD")} {t("PLAYER")} {t("STOP")} {t("TIME")}
                            </Button>
                          )}
                        </h5>
                      </div>
                      <div className="form-part">
                        {playerStopTime?.map((item: any, index: number) => (
                          <div className="flex-container">
                            <Field name={"reason" + index}>
                              {({ input, meta }) => (
                                <div className="flex-item">
                                  <label>
                                    {t("STOP")} {t("REASON")}*
                                  </label>
                                  <input
                                    {...input}
                                    type="text"
                                    value={item?.reason}
                                    onChange={(e) => {
                                      handlePlayerStopTimeChanges(
                                        index,
                                        "reason",
                                        e.target.value
                                      );
                                    }}
                                  />
                                  {meta.error && meta.touched && (
                                    <span>{meta.error}</span>
                                  )}
                                </div>
                              )}
                            </Field>
                            <Field name={"stop_at" + index}>
                              {({ input, meta }) => (
                                <div className="flex-item">
                                  <label>
                                    {t("STOP")} {t("AT")} *
                                  </label>
                                  <SelectPicker
                                    data={generateTimeOptions()}
                                    valueKey="value"
                                    labelKey="label"
                                    onSelect={(value, item) => {
                                      handlePlayerStopTimeChanges(
                                        index,
                                        "stop_at",
                                        value
                                      );
                                    }}
                                    onClean={(e: any) => {
                                      handlePlayerStopTimeChanges(
                                        index,
                                        "stop_at",
                                        ""
                                      );
                                    }}
                                    name={"stop_at" + index}
                                    defaultValue={item?.stop_at
                                      .toString()
                                      .slice(0, 5)}
                                    value={item?.stop_at.toString().slice(0, 5)}
                                  />

                                  {meta.error && meta.touched && (
                                    <span>{meta.error}</span>
                                  )}
                                </div>
                              )}
                            </Field>
                            <Field name={"stop_end_at" + index}>
                              {({ input, meta }) => (
                                <div className="flex-item">
                                  <label>
                                    {t("END")} {t("AT")} *
                                  </label>
                                  <SelectPicker
                                    data={generateTimeOptions()}
                                    valueKey="value"
                                    labelKey="label"
                                    onSelect={(value, item) => {
                                      handlePlayerStopTimeChanges(
                                        index,
                                        "stop_end_at",
                                        value
                                      );
                                    }}
                                    onClean={(e: any) => {
                                      handlePlayerStopTimeChanges(
                                        index,
                                        "stop_end_at",
                                        ""
                                      );
                                    }}
                                    name={"stop_end_at" + index}
                                    defaultValue={item?.stop_end_at
                                      .toString()
                                      .slice(0, 5)}
                                    value={item?.stop_end_at
                                      .toString()
                                      .slice(0, 5)}
                                  />

                                  {meta.error && meta.touched && (
                                    <span>{meta.error}</span>
                                  )}
                                </div>
                              )}
                            </Field>
                            {(playerStopTime?.length == 0 ||
                              index === playerStopTime?.length - 1) && (
                              <div className=" mb-2 text-right">
                                <label>{t("ACTION")}</label>
                                <InputGroup>
                                  <InputGroup.Button
                                    title={t("ADD")}
                                    onClick={() => addPlayerStopTime(index)}
                                  >
                                    <SaveIcon />
                                  </InputGroup.Button>
                                  <InputGroup.Button
                                    title={t("CLEAR")}
                                    onClick={() => removePlayerStopTime(index)}
                                  >
                                    <CloseIcon />
                                  </InputGroup.Button>
                                </InputGroup>
                              </div>
                            )}
                          </div>
                        ))}
                      </div>

                      <div className="create-action d-flex flex-end">
                        <Button
                          appearance="primary"
                          color="red"
                          type="button"
                          onClick={(e: any) => {
                            setOpenModal("");
                          }}
                        >
                          {t("CLOSE")}
                        </Button>
                        <Button
                          appearance="primary"
                          color="green"
                          type="submit"
                        >
                          {+masterRuleId > 0 ? t("UPDATE") : t("CREATE")}
                        </Button>
                      </div>
                    </form>
                  </>
                )}
              />
            </Content>
          </Container>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    </div>
  );
}

export default CompanyMasterRule;
